export interface DanceManagerPassesPublicResponseInterface {
  id?: string;
  name?: string;
  description?: string;
  accessTargetNames?: string[];
  targetIds?: string[];
  numberOfUses?: number;
  quantity?: number;
  soldQuantity?: number;
  price?: number;
  sequenceNumber?: number;
  trial?: boolean;
}
